import { render } from "./DashboardComponent.vue?vue&type=template&id=2335dd9d&scoped=true"
import script from "./DashboardComponent.vue?vue&type=script&lang=js"
export * from "./DashboardComponent.vue?vue&type=script&lang=js"

import "./DashboardComponent.vue?vue&type=style&index=0&id=2335dd9d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2335dd9d"]])

export default __exports__